module.exports = __webpack_public_path__ + "img/bjg.e78dc27e.png";